import request from "@/api/Request";

let baseUrl = "/api/v1/endUser";
let nationalUrl = "/api/v1/national";
let useSystemRulesManagementUrl = "/api/v1/public";
let personalInformationRulesManagementUrl = "/api/v1/public";
let publicUrlPrefix = "/api/v1/public"
let UserAPI = {
    getUseSystemRules() {
        return request.get(
            useSystemRulesManagementUrl + "/getUseSystemRules",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getPersonalInformationRules() {
        return request.get(
            personalInformationRulesManagementUrl + "/getPersonalInformationRules",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getCommerceLawRules() {
        return request.get(
            publicUrlPrefix + "/getCommerceLawRules",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getUseSystemRulesByEndUser() {
        return request.get(
            baseUrl + "/getUseSystemRules",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getBookingPaymentRulesByEndUser() {
        return request.get(
            baseUrl + "/getBookingPaymentRules",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getPersonalInformationRulesByEndUser() {
        return request.get(
            baseUrl + "/getPersonalInformationRules",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    checkUsernameWasUsed(username) {
        return request.get(
            baseUrl + "/isUsernameWasUsed?username=" + username,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    sendEmailToConfirm(email, confirmPwRequest) {
        return request.post(baseUrl + "/sendEmailToConfirm?email=" + email, confirmPwRequest);
    },

    reSendEmail(endUserCode) {
        return request.post(
            baseUrl + "/reSendEmail?endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    isRegistrationExpiredOrUserNotExist(username, endUserCode) {
        return request.get(
            baseUrl + "/isRegistrationExpiredOrUserNotExist?username=" + username + "&endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    confirmPassword(username, confirmPwRequest, userCode) {
        return request.post(baseUrl + "/confirmPassword?username=" + username + "&endUserCode=" + userCode, confirmPwRequest, {
            headers: {
                'Content-Type': undefined
            }
        });
    },

    isPasswordConfirmedAndUnexpiredAndUserExist(username, endUserCode) {
        return request.get(
            baseUrl + "/isPasswordConfirmedAndUnexpiredAndUserExist?username=" + username + "&endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    isEmailWasSendAndEndUserIsNotActive(endUserCode) {
        return request.get(
            baseUrl + "/isEmailWasSendAndEndUserIsNotActive?endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getBaseInfoAndCheckConfirmationPasswordAndRegisterUnexpired(username, endUserCode) {
        return request.get(
            baseUrl + "/getBaseInfoAndCheckConfirmationPasswordAndRegisterUnexpired?username=" + username + "&endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    getNations() {
        return request.get(
            nationalUrl + "/list",
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )

    },

    saveBaseInfo(endUserBaseInfo) {
        return request.post(
            baseUrl + "/saveBaseInfo",
            endUserBaseInfo,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    activeEndUser(endUserCode) {
        return request.post(
            baseUrl + "/activate?endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    changePassword(changePwRequest) {
        return request.post(baseUrl + "/changePassword", changePwRequest, {
            headers: {
                'Content-Type': undefined
            }
        });
    },

    getBaseInfo(endUserCode) {
        return request.get(
            baseUrl + "/getBaseInfo?endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    updateBaseInfo(endUserBaseInfo) {
        return request.post(
            baseUrl + "/update",
            endUserBaseInfo,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    sendEmailToConfirmChanging(email) {
        return request.post(
            baseUrl + "/sendEmailToConfirmChanging?changedEmail=" + email,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    checkEmailExisting(email) {
        return request.get(
            baseUrl + "/checkEmailExisting?endUserEmail=" + email,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    sendEmailToConfirmResetPassword(email) {
        return request.post(
            baseUrl + "/resetPassword/sendEmailToConfirmResetPassword?endUserEmail=" + email,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    isExpiredResetPassword(endUserEmail, resetToken) {
        return request.get(
            baseUrl + "/resetPassword/changePassword?email=" + endUserEmail + "&resetToken=" + resetToken,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    resetPassword(changePwRequest, endUserEmail) {
        return request.post(
            baseUrl + "/resetPassword?endUserEmail=" + endUserEmail, changePwRequest,
            {
                headers: {
                'Content-Type': undefined
            }
        });
    },

    setTokenExpired(resetToken){
        return request.get(
            baseUrl + "/resetPassword/setTokenExpired?resetToken=" + resetToken,
            {
                headers: {
                'Content-Type': undefined
            }
        });
    },

    checkEmailWasActivatedOrIsConfirming(email) {
        return request.get(
            baseUrl + "/checkEmailWasActivatedOrIsConfirming?email=" + email,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    isEmailUserWantToChangeExactly(emailWantToChange, endUserCode) {
        return request.get(
            baseUrl + "/isEmailUserWantToChangeExactly?emailWantToChange=" + emailWantToChange + "&endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    },

    changeEmail(email, endUserCode) {
        return request.post(
            baseUrl + "/changeEmail?email=" + email + "&endUserCode=" + endUserCode,
            {
                headers: {
                    'Content-Type': undefined
                }
            }
        )
    }

};

export default UserAPI;
